<template>
    <div ref="Chart" style="height: 100%;"></div>
</template>

<script>
    //import * as echarts from "echarts";
    import * as echarts from "echarts/core";
    import {
        GridComponent,
        VisualMapComponent,
        MarkLineComponent,
        TooltipComponent,
        LegendComponent
    } from "echarts/components";
    import { LineChart }           from "echarts/charts";
    import { UniversalTransition } from "echarts/features";
    import { CanvasRenderer }      from "echarts/renderers";

    export default {
        name: "ChartVue",

        props: [
            "options",
            "setTheme",
        ],

        data () {
            return {
                chart:         null,
                chartOptions:  null,
                resizeHandler: null,
                /*
                themeDark: {
                    version: 1,
                    themeName: "dark",
                    theme: {
                        seriesCnt: "4",
                        backgroundColor: "rgba(51,51,51,1)",
                        titleColor: "#eeeeee",
                        subtitleColor: "#aaaaaa",
                        textColorShow: false,
                        textColor: "#333",
                        markTextColor: "#eeeeee",
                        color: [
                            "#dd6b66",
                            "#759aa0",
                            "#e69d87",
                            "#8dc1a9",
                            "#ea7e53",
                            "#eedd78",
                            "#73a373",
                            "#73b9bc",
                            "#7289ab",
                            "#91ca8c",
                            "#f49f42"
                        ],
                        borderColor: "#cccccc",
                        borderWidth: 0,
                        visualMapColor: [
                            "#bf444c",
                            "#d88273",
                            "#f6efa6"
                        ],
                        legendTextColor: "#eeeeee",
                        kColor: "#fd1050",
                        kColor0: "#0cf49b",
                        kBorderColor: "#fd1050",
                        kBorderColor0: "#0cf49b",
                        kBorderWidth: 1,
                        lineWidth: 2,
                        symbolSize: 4,
                        symbol: "circle",
                        symbolBorderWidth: 1,
                        lineSmooth: false,
                        graphLineWidth: 1,
                        graphLineColor: "#aaaaaa",
                        mapLabelColor: "#000",
                        mapLabelColorE: "rgb(100,0,0)",
                        mapBorderColor: "#444",
                        mapBorderColorE: "#444",
                        mapBorderWidth: 0.5,
                        mapBorderWidthE: 1,
                        mapAreaColor: "#eee",
                        mapAreaColorE: "rgba(255,215,0,0.8)",
                        axes: [
                            {
                                type: "all",
                                name: "通用坐标轴",
                                axisLineShow: true,
                                axisLineColor: "#eeeeee",
                                axisTickShow: true,
                                axisTickColor: "#eeeeee",
                                axisLabelShow: true,
                                axisLabelColor: "#eeeeee",
                                splitLineShow: true,
                                splitLineColor: [
                                    "#aaaaaa"
                                ],
                                splitAreaShow: false,
                                splitAreaColor: [
                                    "#eeeeee"
                                ]
                            },
                            {
                                type: "category",
                                name: "类目坐标轴",
                                axisLineShow: true,
                                axisLineColor: "#333",
                                axisTickShow: true,
                                axisTickColor: "#333",
                                axisLabelShow: true,
                                axisLabelColor: "#333",
                                splitLineShow: false,
                                splitLineColor: [
                                    "#ccc"
                                ],
                                splitAreaShow: false,
                                splitAreaColor: [
                                    "rgba(250,250,250,0.3)",
                                    "rgba(200,200,200,0.3)"
                                ]
                            },
                            {
                                type: "value",
                                name: "数值坐标轴",
                                axisLineShow: true,
                                axisLineColor: "#333",
                                axisTickShow: true,
                                axisTickColor: "#333",
                                axisLabelShow: true,
                                axisLabelColor: "#333",
                                splitLineShow: true,
                                splitLineColor: [
                                    "#ccc"
                                ],
                                splitAreaShow: false,
                                splitAreaColor: [
                                    "rgba(250,250,250,0.3)",
                                    "rgba(200,200,200,0.3)"
                                ]
                            },
                            {
                                type: "log",
                                name: "对数坐标轴",
                                axisLineShow: true,
                                axisLineColor: "#333",
                                axisTickShow: true,
                                axisTickColor: "#333",
                                axisLabelShow: true,
                                axisLabelColor: "#333",
                                splitLineShow: true,
                                splitLineColor: [
                                    "#ccc"
                                ],
                                splitAreaShow: false,
                                splitAreaColor: [
                                    "rgba(250,250,250,0.3)",
                                    "rgba(200,200,200,0.3)"
                                ]
                            },
                            {
                                type: "time",
                                name: "时间坐标轴",
                                axisLineShow: true,
                                axisLineColor: "#333",
                                axisTickShow: true,
                                axisTickColor: "#333",
                                axisLabelShow: true,
                                axisLabelColor: "#333",
                                splitLineShow: true,
                                splitLineColor: [
                                    "#ccc"
                                ],
                                splitAreaShow: false,
                                splitAreaColor: [
                                    "rgba(250,250,250,0.3)",
                                    "rgba(200,200,200,0.3)"
                                ]
                            }
                        ],
                        axisSeperateSetting: false,
                        toolboxColor: "#999999",
                        toolboxEmphasisColor: "#666666",
                        tooltipAxisColor: "#eeeeee",
                        tooltipAxisWidth: "1",
                        timelineLineColor: "#eeeeee",
                        timelineLineWidth: 1,
                        timelineItemColor: "#dd6b66",
                        timelineItemColorE: "#a9334c",
                        timelineCheckColor: "#e43c59",
                        timelineCheckBorderColor: "#c23531",
                        timelineItemBorderWidth: 1,
                        timelineControlColor: "#eeeeee",
                        timelineControlBorderColor: "#eeeeee",
                        timelineControlBorderWidth: 0.5,
                        timelineLabelColor: "#eeeeee",
                        datazoomBackgroundColor: "rgba(47,69,84,0)",
                        datazoomDataColor: "rgba(255,255,255,0.3)",
                        datazoomFillColor: "rgba(167,183,204,0.4)",
                        datazoomHandleColor: "#a7b7cc",
                        datazoomHandleWidth: "100",
                        datazoomLabelColor: "#eeeeee"
                    }
                }
                */
            }
        },

        mounted () {
            this.resizeHandler = new ResizeObserver(this.onResize)
                .observe(this.$refs.Chart);
        },


        beforeDestroy () {
            if (this.resizeHandler) {
                this.resizeHandler.unobserve(this.$refs.onResize);
            }

            if (this.chart !== null) {
                this.chart.dispose();
            }
        },

        watch: {
            options: {
                handler: function () {
                    this.draw();
                },
                deep: true
            },

            "$store.getters.user.settings.darkTheme": {
                handler: function () {
                    this.draw();
                }
            }
        },

        methods: {
            /**
             * Очищает график
             */
            clear () {
                if (this.chart !== null) {
                    this.chart.clear();
                }
            },

            /**
             *  Отрисовывает график
             */
            draw () {
                if (this.chart !== null) {
                    this.chart.dispose();
                }
                /*
                this.chart = echarts.init(this.$refs.Chart, this.themeDark); //, this.setTheme);
                this.options && this.chart.setOption(this.options);
                */

                if (this.$refs.Chart == null || this.$refs.Chart == undefined) {
                    return;
                }

                echarts.use([
                    GridComponent,
                    VisualMapComponent,
                    MarkLineComponent,
                    TooltipComponent,
                    LegendComponent,
                    LineChart,
                    CanvasRenderer,
                    UniversalTransition
                ]);

                this.chart = this.setTheme == "auto"
                    ? echarts.init(this.$refs.Chart, this.$store.getters.user.settings.darkTheme ? "dark" : "light")
                    : echarts.init(this.$refs.Chart, this.setTheme);

                this.chartOptions = { ...this.options };

                if (this.chartOptions.yAxis) {
                    if  (!this.chartOptions.yAxis.splitLine) {
                        this.chartOptions.yAxis.splitLine = {}
                    }

                    if  (!this.chartOptions.yAxis.splitLine.lineStyle) {
                        this.chartOptions.yAxis.splitLine.lineStyle = { color: "#aaa" }
                    }
                }

                if (this.setTheme == "dark" || (this.setTheme == "auto" && this.$store.getters.user.settings.darkTheme)) {
                    this.chartOptions.backgroundColor = "#424242"; //"#212121";
                    if (!this.chartOptions.Axis) {
                        this.chartOptions.Axis = {}
                    }

                    //this.options.yAxis.splitLine.lineStyle.color = "#aaa";
                } else if (this.chartOptions.backgroundColor) {
                    delete this.chartOptions.backgroundColor;

                    //this.options.yAxis.splitLine.lineStyle.color = "#aaa";
                }
                /*
                } else {
                    if (this.options.backgroundColor) {
                        delete this.options.backgroundColor;
                    }

                    this.options.yAxis.splitLine.lineStyle.color = "#aaa";
                }
                */

                //this.$debug.log(this.chart);

                /*
                this.chart.on("click", (params) => {
                    this.$debug.log(["click", params]);
                    this.$emit("click", params);
                });
                */


                this.chart.on("legendselectchanged", (params) => {
                    // this.$debug.log(["legendselectchanged", params]);
                    this.$emit("legendSelectChanged", params);
                });

                this.chart.on("click", "series.line", (params) => {
                    // this.$debug.log(["click series.line", params]);
                    this.$emit("click", params);
                });

                this.chart.on("mouseover", {seriesIndex: 1, name: "xx"}, (params) => {
                    // this.$debug.log(["mouseover", params]);
                    this.$emit("mouseOver", params);
                });

                this.chart.on("highlight", (params) => {
                    // this.$debug.log(["highlight", params]);
                    this.$emit("highlight", params);
                });

                this.chartOptions && this.chart.setOption(this.chartOptions);
                /**/
            },

            onResize () {
                this.draw();
            }
        }
    }
</script>
